import { MAX_TITLE_LENGTH_WITHOUT_BRAND } from '@glass/common/modules/content/titleLengths';
import { SPACE_STRING } from '@glass/common/modules/strings/constants';
import filterJoin from '@glass/common/modules/strings/filterJoin';
import capitalizeFirstLetter from '@glass/common/modules/utils/capitalizeFirstLetter';

const truncateTitle = (title: string, maxLength: number) =>
  title.length > maxLength
    ? title
        .slice(0, maxLength)
        .replace(/\W+\S*$/, '')
        .trim()
    : title;

interface TitleGenerationOptions {
  name: string;
  postFixes?: string[];
  maxLength?: number;
  postFixStart?: number;
  normalize?: boolean;
}

const generateTitle = ({
  name,
  postFixes = ['resumes'],
  maxLength = MAX_TITLE_LENGTH_WITHOUT_BRAND,
  postFixStart = 1,
  normalize = false,
}: TitleGenerationOptions) => {
  const normalizedTitle = normalize ? capitalizeFirstLetter(name.toLowerCase()) : name;
  let title = filterJoin([normalizedTitle, ...postFixes.slice(0, postFixStart)], SPACE_STRING);

  if (title.length >= maxLength) {
    return `${truncateTitle(normalizedTitle, maxLength - postFixes[0].length)} ${postFixes[0]}`;
  }

  for (let i = postFixStart; i < postFixes.length; i += 1) {
    const potentialTitle = `${title} ${postFixes[i]}`;
    if (potentialTitle.length < maxLength) {
      title = potentialTitle;
    } else {
      break;
    }
  }

  return title;
};

export default generateTitle;
